var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWifi = function SvgWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.155,
    height: 42.869
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M59.834 12.31a42.13 42.13 0 0 0-59.513 0 1.1 1.1 0 0 0 1.549 1.545 39.937 39.937 0 0 1 56.414 0 1.095 1.095 0 1 0 1.55-1.545",
    "data-name": "Path 51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M6.762 18.745a1.1 1.1 0 1 0 1.548 1.549 30.817 30.817 0 0 1 43.534 0 1.1 1.1 0 0 0 1.549-1.549 33.01 33.01 0 0 0-46.631 0",
    "data-name": "Path 52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M30.078 18.206a23.7 23.7 0 0 0-16.876 6.98 1.1 1.1 0 0 0 1.549 1.549 21.7 21.7 0 0 1 30.654 0 1.1 1.1 0 0 0 1.549-1.549 23.7 23.7 0 0 0-16.876-6.98",
    "data-name": "Path 53"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M30.078 28.513a7.178 7.178 0 1 0 7.178 7.178 7.186 7.186 0 0 0-7.178-7.178m0 12.164a4.987 4.987 0 1 1 4.987-4.987 4.99 4.99 0 0 1-4.987 4.987",
    "data-name": "Path 54"
  })));
};
export default SvgWifi;